import revealPriceListApi from "../../../api/revealPriceList/revealPriceList";

const state = {
};

const getters = {};

const mutations = {
};

const actions = {
  revealPriceList({ state }, { params, callback }) {
    console.log(state);
    revealPriceListApi.revealPriceListApi({ params, callback }, res => {
      callback(res);
    });
  },
  checkPropertyRevealedByUser({ state }, { params, callback }) {
    console.log(state);
    revealPriceListApi.checkPropertyRevealedByUserApi({ params, callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/revealPriceList/revealPriceList.js